import { useNavigate } from 'react-router-dom'

import { SettingsInternalFoldersPageHeaderQuery } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import getTitle from 'modules/documents/components/Documents/getTitle'
import { FoldersHeader } from 'modules/documents/components/Settings/FoldersHeader'

type Folder =
  SettingsInternalFoldersPageHeaderQuery['documents']['foldersConnection']['edges'][number]['node']

type Props = {
  folder: NonNullable<Folder>
}

const InternalFolderIndexPageHeader = ({ folder }: Props) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const title = i18n.t('settings.folders.list.inside_folder.title', {
    folder_name: getTitle(folder.name)
  })

  return (
    <FoldersHeader
      title={title}
      description={i18n.t('settings.folders.list.company.description')}
      onCreateButton={() =>
        navigate(navigation.settings.folders.internal.show.new.fullPath({ id: folder.id }))
      }
    />
  )
}

export default InternalFolderIndexPageHeader
